import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Advertesing from 'views/machine/cashier/advertising'; // Importing Advertesing component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * CashierView class extending JetView to create a cashier interface.
 */
export default class CashierView extends JetView {
    /**
     * Configures the UI components of the CashierView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Second toolbar configuration (duplicate of the first)
        const toolbar2 = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Same ID as the first toolbar's pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(),
                },
            ],
        };

        // Left panel configuration
        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false,
            paddingX: 15,
            paddingY: 10,
            css: 'cajeros', // CSS class for styling
            rows: [
                Advertesing, // Including the Advertesing component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Returning the main configuration object for the view
        return {
            view: 'form', // Main view type
            type: 'wide', // Form type
            responsive: true, // Enable responsive design
            scroll: true, // Enable scrolling
            rows: [left], // Main rows of the form
        };
    }
}

// FILE DOCUMENTED
